import { Alert, Button, FormControl, TextField } from "@mui/material";
import { useCallback, useContext, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { signInWithEmailAndPassword } from "firebase/auth";
import { Link, Navigate } from "react-router-dom";
import { Logo } from "../../components/Logo";
import { auth } from "../../libs/firebase";
import { Messages } from "../../messages";
import { Loader } from "../../components/Loader";
import AppContext from "../../context";

export default function Login() {
  const { fbUser } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const clearErrors = useCallback(() => {
    setError("");
  }, []);

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email(Messages.validations.validEmail)
      .required(Messages.validations.required),
    password: Yup.string()
      .min(7, Messages.validations.minLenght(7))
      .required(Messages.validations.required),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: false,
    onSubmit: async (values) => {
      setIsLoading(true);
      clearErrors();

      try {
        await signInWithEmailAndPassword(auth, values.email, values.password);
      } catch {
        setError("correo electrónico o contraseña inválida.");
        formik.setFieldValue("password", formik.initialValues.password);
        setIsLoading(false);
      }
    },
  });

  if (fbUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      {isLoading && <Loader />}

      <div className="bg-[#F7F7FF] w-screen h-screen fixed top-0 left-0 flex justify-center items-center">
        <form
          method="POST"
          className="bg-white p-6 box-border w-full max-w-[410px] rounded-md flex flex-col gap-3"
          onSubmit={formik.handleSubmit}
        >
          <div className="mb-4 flex justify-center">
            <Logo />
          </div>

          {error && <Alert severity="error">{error}</Alert>}

          <FormControl fullWidth>
            <TextField
              label="Correo electrónico"
              type="email"
              name="email"
              variant="outlined"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={!!formik.errors.email}
              helperText={formik.errors.email}
            />
          </FormControl>

          <FormControl fullWidth>
            <TextField
              label="Contraseña"
              type="password"
              name="password"
              variant="outlined"
              value={formik.values.password}
              onChange={formik.handleChange}
              error={!!formik.errors.password}
              helperText={formik.errors.password}
            />
          </FormControl>

          <div className="flex gap-6 justify-between items-center">
            <Button
              variant="contained"
              size="large"
              type="submit"
              fullWidth
              disableElevation
            >
              Entrar
            </Button>

            <Link to="/" className="link text-sm whitespace-nowrap">
              ¿Olvidó su contraseña?
            </Link>
          </div>
        </form>
      </div>
    </>
  );
}
